import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

import { AutomationsPresentationV1 } from 'Automations/automationEditor/types'
import { ResolvedNodeDefinitions } from 'Automations/nodeDefinitions/types'
import { presentationToVersionParams } from '../presentationToVersionParams'

export const saveNewAutomation = async ({
  name,
  description,
  presentation,
  definitions
}: {
  name: string
  description: string
  presentation: AutomationsPresentationV1
  definitions: ResolvedNodeDefinitions
}): Promise<string> => {
  const { apiPresentation, workflowDefinition, triggerType } =
    presentationToVersionParams({
      name,
      description,
      presentation,
      definitions
    })

  const resPostAutomation = await dashboardv99990101Client.postAutomation({
    // for new automation
    name,
    description,
    // for initially created version
    triggerType,
    workflowDefinition,
    presentation: apiPresentation
  })

  if (!resPostAutomation.data || resPostAutomation.error) {
    throw new Error('Unable to create automation')
  }

  return resPostAutomation.data.id
}
